import type { OrderStatus } from '../../types';

export const STATUS_LABEL: Record<OrderStatus, string> = {
  pending: 'Pending',
  confirmed: 'Confirmed',
  dispatched: 'Dispatched',
  delivered: 'Delivered',
  cancelled: 'Cancelled',
};

export const STATUS_TONE: Record<OrderStatus, 'neutral' | 'brand' | 'warning' | 'success' | 'danger'> = {
  pending: 'warning',
  confirmed: 'brand',
  dispatched: 'brand',
  delivered: 'success',
  cancelled: 'danger',
};

/** The verb on the button, not the noun on the badge. */
export const STATUS_ACTION: Record<string, string> = {
  confirmed: 'Confirm',
  dispatched: 'Mark dispatched',
  delivered: 'Mark delivered',
  cancelled: 'Cancel order',
};

/**
 * Indian digit grouping, because ₹12,34,567 is what the reader expects
 * and ₹1,234,567 reads as a different number to them.
 */
export function money(amount: number | null | undefined, withSymbol = true): string {
  if (amount == null) return '—';
  const formatted = new Intl.NumberFormat('en-IN', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
  return withSymbol ? `₹${formatted}` : formatted;
}

/** For totals in a header, where the paise are noise. */
export function moneyShort(amount: number | null | undefined): string {
  if (amount == null) return '—';
  if (Math.abs(amount) >= 10_000_000) return `₹${(amount / 10_000_000).toFixed(2)} Cr`;
  if (Math.abs(amount) >= 100_000) return `₹${(amount / 100_000).toFixed(2)} L`;
  return `₹${new Intl.NumberFormat('en-IN', { maximumFractionDigits: 0 }).format(amount)}`;
}

export function quantity(value: number, unit: string): string {
  const rounded = Number.isInteger(value) ? String(value) : String(Number(value.toFixed(3)));
  return `${rounded} ${unit}`;
}

export const GST_RATES = [0, 0.25, 3, 5, 12, 18, 28];

export function today(timeZone?: string): string {
  return new Intl.DateTimeFormat('en-CA', { timeZone: timeZone || undefined })
    .format(new Date());
}

export function daysAgo(n: number, timeZone?: string): string {
  const d = new Date();
  d.setDate(d.getDate() - n);
  return new Intl.DateTimeFormat('en-CA', { timeZone: timeZone || undefined }).format(d);
}
